export default __webpack_public_path__ + "static/media/grid.010.b2c3c63a.jpeg";